<template>
  <ValidationProvider :rules="validationRule" v-slot="{ errors, dirty, valid , classes }" tag="div" class="form-group">
    <label :for="name" :class="classes"> {{ label }} </label>

    <select
      class="form-control"
      :class="classes"
      :name="name"
      :type="inputType"
      :value="value"
      @change="$emit('input', $event.target.value)"
      @input="$emit('input', $event.target.value)"
    >
      <option value="" disabled> {{placeholder}} </option>
      <option v-for="(option, idx) in options" :key="idx" :value="option.value"> {{ option.name }} </option>

    </select>
    <ul class="errors">
      <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
    </ul>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'basicSelect',
  props: ['name', 'label', 'placeholder', 'value', 'inputType', 'options', 'validationRule'],
  data() {
    return {
      inputValue: '',
    };
  },
  created() {
    this.inputValue = this.value;
  },
  methods: {
    handleInputChange() {
      this.$emit('inputChange', { name: this.name, value: this.inputValue });
    },
  },
};

</script>

<style scoped>

  label {
    margin-right: 15px;
    width: auto;
    min-width: 100px;
  }
</style>
